import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { calculatePrice, formatDisplayPrice } from "../../utils/priceHandler";
import useLoadDBImage from "../../hooks/useLoadDBImage";
import ProductPrice from "../product/ProductPrice";

const BundleCheckoutItem = ({ bundle }) => {
  const submittedPromoCodes = useSelector(state => state.cart.submittedPromoCodes);
  const rawTotal = bundle.bundleRawTotal * bundle.quantity;
  const subtotal = calculatePrice(bundle.bundleTotal, bundle.quantity, false, submittedPromoCodes);
  const savings = bundle.bundleDiscount * bundle.quantity;


  return (
    <div className="cart-item-simplified flex flex-col gap-3 mb-3">
      <div className="flex gap-3 justify-between min-h-[110px]">
        <div className="flex">
          <div className="relative">
            <div className="cart-item-image w-20 h-20 rounded-10 overflow-hidden flex items-center justify-center">
              {bundle.products.map((item, index) => {
                const imageUrl = useLoadDBImage("onProductImages", null, item.id, item.imageId);
                return (
                  <div
                    key={item.cartId}
                    className="absolute w-16 h-16 bg-secondary-light rounded-8 overflow-hidden border-2 border-white"
                    style={{
                      top: `${index * 16}px`,
                      zIndex: bundle.products.length - index
                    }}
                  >
                    {imageUrl && <img src={imageUrl} alt={item.name} className="w-full h-full object-cover" />}
                  </div>
                );
              })}
            </div>
            <div className="cart-count">{bundle.quantity}</div>
          </div>

          <div className="pl-4">
            <div className='flex items-start gap-4 gap-y-1 mb-2'>
              <p className="text-lg font-medium mb-0">{bundle.name || 'Product Bundle'}</p>
              {savings > 0 && <p className='saved mb-0 whitespace-nowrap'>Save ${savings}</p>}
            </div>

            {/* Bundle products list */}
            <div className="mt-2 space-y-1">
              {bundle.products.map((item) => (
                <p className="text-xs mb-1">{item.name}</p>
              ))}
            </div>
          </div>
        </div>

        <div className="flex flex-col-reverse justify-end items-end">
          <div className="product-price flex flex-col-reverse justify-end items-end">
            <span className="text-mid">{formatDisplayPrice(subtotal)}</span>
            {savings > 0 && (
              <span className="ml-2 text-sm text-gray-500 line-through">
                {formatDisplayPrice(rawTotal)}
              </span>
            )}
          </div>

        </div>
      </div>
    </div>
  );
};

BundleCheckoutItem.propTypes = {
  bundle: PropTypes.shape({
    name: PropTypes.string,
    quantity: PropTypes.number.isRequired,
    bundleRawTotal: PropTypes.number.isRequired,
    bundleTotal: PropTypes.number.isRequired,
    bundleDiscount: PropTypes.number.isRequired,
    products: PropTypes.arrayOf(PropTypes.shape({
      cartId: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      id: PropTypes.number.isRequired,
      imageId: PropTypes.string
    })).isRequired
  }).isRequired
};

export default BundleCheckoutItem;